import styled from 'styled-components'
import { BORDER, SPACING } from 'app-v2/design-tokens'
import { colors } from 'app-v2/design-systems/theme'

export const CardContainer = styled.div`
    display: flex;
    flex-direction: ${props => (props.flexDirectionRow ? 'row' : 'column')};
    justify-content: space-between;
    align-items: flex-start;
    background: ${colors.white};
    padding: ${SPACING.M};
    border-radius: ${BORDER.RADIUS.M};
    width: 100%;

    ${({ center }) =>
        center &&
        `
            align-items: center;
        `};
`
